import { MarketingShell } from "@/components/landing/MarketingShell";
import { SeoHead } from "@/components/useSeo";
import { MarketingLink } from "@/components/OptionalLink";
import { Templates } from "@/components/landing/Templates";

const Page = () => (
  <MarketingShell>
    <SeoHead
      path="popular"
      title="Popular Open Source Apps — DollarDeploy"
      description="Deploy popular open source applications with one click. All templates are pre-configured and ready to go."
    />
    <section className="container py-20 flex flex-col gap-10">
      <Templates landing />
      <div className="text-center pb-16">
        <MarketingLink
          href="/r"
          className="inline-block border rounded-full px-6 py-3 text-sm font-medium hover:bg-foreground hover:text-background hover:border-foreground transition-colors"
        >
          Browse all templates →
        </MarketingLink>
      </div>
    </section>
  </MarketingShell>
);

export default Page;
